export const isFeatureEnabled = (featureName) => process.env[`REACT_APP_TOGGLE_${featureName}`] === 'true';
